import { render, staticRenderFns } from "./AdminSubjectsView.vue?vue&type=template&id=da92dec8"
import script from "./AdminSubjectsView.vue?vue&type=script&lang=ts"
export * from "./AdminSubjectsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports